/**
 * FaceSwap 选项配置 - 国际化版本
 * 使用翻译键引用，支持多语言
 */

export const envOptions = [
  {
    name: "aiWorkbench.faceSwap.categories.environment",
    key: "environment",
    children: [
      {
        name: "aiWorkbench.faceSwapeEnvOptions.environment.environmentAtmosphere.label",
        key: "environment_atmosphere",
        options: [
          { key: "warm_sunlight", label: "aiWorkbench.faceSwapeEnvOptions.environment.environmentAtmosphere.options.warmSunlight" },
          { key: "cool_tone", label: "aiWorkbench.faceSwapeEnvOptions.environment.environmentAtmosphere.options.coolTone" },
          { key: "dark_atmosphere", label: "aiWorkbench.faceSwapeEnvOptions.environment.environmentAtmosphere.options.darkAtmosphere" },
          { key: "cloudy_hazy", label: "aiWorkbench.faceSwapeEnvOptions.environment.environmentAtmosphere.options.cloudyHazy" },
          { key: "light_through_window", label: "aiWorkbench.faceSwapeEnvOptions.environment.environmentAtmosphere.options.lightThroughWindow" }
        ]
      },
      {
        name: "aiWorkbench.faceSwapeEnvOptions.environment.lightStyle.label",
        key: "light_style",
        options: [
          { key: "natural_sunlight", label: "aiWorkbench.faceSwapeEnvOptions.environment.lightStyle.options.naturalSunlight" },
          { key: "soft_ambient_light", label: "aiWorkbench.faceSwapeEnvOptions.environment.lightStyle.options.softAmbientLight" },
          { key: "harsh_sunlight", label: "aiWorkbench.faceSwapeEnvOptions.environment.lightStyle.options.harshSunlight" },
          { key: "overcast_sky", label: "aiWorkbench.faceSwapeEnvOptions.environment.lightStyle.options.overcastSky" },
          { key: "sunset_glow", label: "aiWorkbench.faceSwapeEnvOptions.environment.lightStyle.options.sunsetGlow" },
          { key: "candlelight", label: "aiWorkbench.faceSwapeEnvOptions.environment.lightStyle.options.candlelight" },
          { key: "moonlight", label: "aiWorkbench.faceSwapeEnvOptions.environment.lightStyle.options.moonlight" },
          { key: "backlit_silhouette", label: "aiWorkbench.faceSwapeEnvOptions.environment.lightStyle.options.backlitSilhouette" },
          { key: "spotlight", label: "aiWorkbench.faceSwapeEnvOptions.environment.lightStyle.options.spotlight" },
          { key: "rim_lighting", label: "aiWorkbench.faceSwapeEnvOptions.environment.lightStyle.options.rimLighting" },
          { key: "studio_lighting", label: "aiWorkbench.faceSwapeEnvOptions.environment.lightStyle.options.studioLighting" },
          { key: "golden_hour_light", label: "aiWorkbench.faceSwapeEnvOptions.environment.lightStyle.options.goldenHourLight" },
          { key: "blue_hour_light", label: "aiWorkbench.faceSwapeEnvOptions.environment.lightStyle.options.blueHourLight" },
          { key: "neon_lights", label: "aiWorkbench.faceSwapeEnvOptions.environment.lightStyle.options.neonLights" }
        ]
      },
      {
        name: "aiWorkbench.faceSwapeEnvOptions.environment.lightDirection.label",
        key: "light_direction",
        options: [
          { key: "from_top", label: "aiWorkbench.faceSwapeEnvOptions.environment.lightDirection.options.fromTop" },
          { key: "from_bottom", label: "aiWorkbench.faceSwapeEnvOptions.environment.lightDirection.options.fromBottom" },
          { key: "from_right", label: "aiWorkbench.faceSwapeEnvOptions.environment.lightDirection.options.fromRight" },
          { key: "from_left", label: "aiWorkbench.faceSwapeEnvOptions.environment.lightDirection.options.fromLeft" },
          { key: "from_front", label: "aiWorkbench.faceSwapeEnvOptions.environment.lightDirection.options.fromFront" },
          { key: "from_top_right", label: "aiWorkbench.faceSwapeEnvOptions.environment.lightDirection.options.fromTopRight" },
          { key: "from_top_left", label: "aiWorkbench.faceSwapeEnvOptions.environment.lightDirection.options.fromTopLeft" }
        ]
      },
      {
        name: "aiWorkbench.faceSwapeEnvOptions.environment.background.label",
        key: "background",
        options: [
          { key: "natural_landscape", label: "aiWorkbench.faceSwapeEnvOptions.environment.background.options.naturalLandscape" },
          { key: "urban_background", label: "aiWorkbench.faceSwapeEnvOptions.environment.background.options.urbanBackground" },
          { key: "simple_background", label: "aiWorkbench.faceSwapeEnvOptions.environment.background.options.simpleBackground" },
          { key: "indoor_background", label: "aiWorkbench.faceSwapeEnvOptions.environment.background.options.indoorBackground" },
          { key: "virtual_background", label: "aiWorkbench.faceSwapeEnvOptions.environment.background.options.virtualBackground" }
        ]
      },
      {
        name: "aiWorkbench.faceSwapeEnvOptions.environment.backgroundEffect.label",
        key: "background_effect",
        options: [
          { key: "dynamic_background", label: "aiWorkbench.faceSwapeEnvOptions.environment.backgroundEffect.options.dynamicBackground" },
          { key: "neon_light_background", label: "aiWorkbench.faceSwapeEnvOptions.environment.backgroundEffect.options.neonLightBackground" },
          { key: "starry_sky_background", label: "aiWorkbench.faceSwapeEnvOptions.environment.backgroundEffect.options.starrySkyBackground" },
          { key: "fog_mist_effect", label: "aiWorkbench.faceSwapeEnvOptions.environment.backgroundEffect.options.fogMistEffect" },
          { key: "minimalist_background", label: "aiWorkbench.faceSwapeEnvOptions.environment.backgroundEffect.options.minimalistBackground" }
        ]
      },
      {
        name: "aiWorkbench.faceSwapeEnvOptions.environment.backgroundBlur.label",
        key: "background_blur",
        options: [
          { key: "slight_blur", label: "aiWorkbench.faceSwapeEnvOptions.environment.backgroundBlur.options.slightBlur" },
          { key: "strong_blur", label: "aiWorkbench.faceSwapeEnvOptions.environment.backgroundBlur.options.strongBlur" },
          { key: "haze_effect", label: "aiWorkbench.faceSwapeEnvOptions.environment.backgroundBlur.options.hazeEffect" }
        ]
      }
    ]
  }
];

export default envOptions;